// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectFurniture-module__grid2--oHCoH {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-flow: row;
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/SelectFurniture/SelectFurniture.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,qCAAqC;IACrC,mBAAmB;AACvB","sourcesContent":[".grid2 {\n    display: grid;\n    gap: 20px;\n    grid-template-columns: repeat(2, 1fr);\n    grid-auto-flow: row;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid2": `SelectFurniture-module__grid2--oHCoH`
};
export default ___CSS_LOADER_EXPORT___;
